import styles from "./info-box.module.css";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";
import { UIIconName } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-type";

interface InfoBoxProps {
  title: string;
  description: string;
  iconName?: UIIconName;
  isMobile?: boolean;
}

export const InfoBox = (props: InfoBoxProps) => {
  if (props.isMobile) {
    return (
      <h2 className={styles.mobileTitle}>{props.title}</h2>
    );
  }

  return (
    <div className={styles.container}>
      {props.iconName && (
        <UIIcon iconName={props.iconName} size={28} variant="REGULAR" />
      )}
      <div className={styles.content}>
        <h2 style={{ textTransform: "uppercase" }} className={styles.title}>
          {props.title}
        </h2>
        <p className={styles.description}>{props.description}</p>
      </div>
    </div>
  );
};
